import i18n from 'i18next';
import * as yup from 'yup';
import contactsFormSchema from './contactsFormSchema';

const missionFormSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required(() => i18n.t('common.message.requiredField')),
  jurisdictions: yup.array().of(contactsFormSchema),
  clientId: yup.number().required(() => i18n.t('common.message.requiredField')),
});

export default missionFormSchema;
